

































import Vue from 'vue';
import { disableBodyScroll, enableBodyScroll } from '../../../common/scroll';

export default Vue.extend({
  name: 'FitHalfScreenDialog',
  props: {
    /** 标题 */
    title: String,
    /** 关闭按钮提示文案 */
    closeAriaLabel: {
      type: String,
      default: '關閉',
    },
    /** tab键序号 */
    tabIndex: {
      type: Number,
      default: -1,
    },
    /** 是否打开 */
    visible: Boolean,
    /** 是否可以点击遮罩层关闭 */
    maskClose: {
      type: Boolean,
      default: true,
    },
    /** 是否隐藏标题区域 */
    hideHeader: {
      type: Boolean,
      default: false,
    },
    /** 是否将DOM移至body中 */
    appendToBody: {
      type: Boolean,
      default: false,
    },
    /** 是否展示关闭按钮 */
    isShowClose: {
      type: Boolean,
      default: true,
    },
    /** 是否展示遮罩层 */
    isShowMask: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    visible(newValue) {
      if (newValue) {
        disableBodyScroll();
        // @ts-ignore
        this.$el.focus();
      } else {
        enableBodyScroll();
      }
    },
  },
  methods: {
    onClose() {
      this.$emit('onClose');
    },
    handleClickMask(e: Event) {
      e.stopPropagation();
      // @ts-ignore
      if (e?.target?.id === 'halfSelfDialog') {
        if (this.maskClose) {
          this.onClose();
        }
      }
    },
    stop(e: Event) {
      e.preventDefault();
    },
  },
  mounted() {
    if (this.appendToBody) {
      document.body.appendChild(this.$el);
    }
  },
  destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.appendToBody && this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    enableBodyScroll();
  },
});
